module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "d3js-icon.9d549e1c.svg" + "?" + Date.now();